"use client";

import { useState, useEffect } from "react";
import { usePathname } from "next/navigation";

export function useServiceData() {
  const pathname = usePathname();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const parts = pathname.split("/").filter(Boolean);
    const slug = parts[parts.length - 1];

    if (slug && slug !== "services") {
      const fetchData = async () => {
        try {
          const apiUrl = (process.env.NEXT_PUBLIC_API_URL || '').replace(/\/api\/?$/, '').replace(/\/$/, '') || "";
          const res = await fetch(`${apiUrl}/api/service/${slug}`, {
            cache: "no-store",
          });
          
          if (res.status === 404) {
            setLoading(false);
            return;
          }
          
          if (!res.ok) {
            setLoading(false);
            return;
          }

          const json = await res.json();
          if (json.success) {
            setData(json.data);
          }
          setLoading(false);
        } catch (err) {
          if (err.name === 'TypeError') {
            console.warn("useServiceData: API server unreachable. Using fallbacks.");
          }
          setError(err);
          setLoading(false);
        }
      };
      fetchData();
    } else {
      setLoading(false);
    }
  }, [pathname]);

  return { data, loading, error };
}
